import script from "./PortfolioInputCard.vue?vue&type=script&setup=true&lang=js"
export * from "./PortfolioInputCard.vue?vue&type=script&setup=true&lang=js"

import "./PortfolioInputCard.vue?vue&type=style&index=0&id=0ae35024&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ae35024"]])

export default __exports__